import { IVideo } from "~/types/video";

export const videos: IVideo[] = [
  {
    url: "https://fast.wistia.net/embed/iframe/4inflthxjw",
    titleKey: "video.overview",
    time: "1:08",
  },
  {
    url: "https://fast.wistia.net/embed/iframe/mantvmk2mk",
    titleKey: "video.import_reviews",
    time: "1:21",
  },
  {
    url: "https://fast.wistia.net/embed/iframe/bxsmziv8gb",
    titleKey: "video.manage_reviews",
    time: "0:32",
  },
  {
    url: "https://fast.wistia.net/embed/iframe/3x4h39l1cp",
    titleKey: "video.edit_widget",
    time: "0:45",
  },
];
